import React, { useEffect, useState } from "react";
import Modal from './index';
import Input from '../Form/Input';
import FormGroup from "../Form/FormGroup";
import Button from "../Form/Button";
import { FiUsers } from "react-icons/fi";
import FormGroupInline from '../Form/FormGroupInline';
import BreakForm from "../Form/BreakForm";
import { HiPlus } from "react-icons/hi";
import Select from "../Form/Select";
import { MdOutlineDelete } from "react-icons/md";
import Textarea from "../Form/Textarea";
import ToggleField from "../Form/ToggleField";
import { useData } from "../../contexts/dataContext";
import DatePicker from "../Form/DatePicker";
import moment from "moment";

const ModalSale = ({ isNew = false, value = {}, onSubmit, closeModal }) => {
    const [data, setData] = useState({ ...value, sold_at: value?.sold_at || new Date().toISOString() })
    const [products, setProducts] = useState(value?.products || [])

    const { products: listProducts } = useData()

    useEffect(() => {
        handleChangeValue('products', products)
    }, [products])

    const handleChangeProduct = (key, value, index) => {
        setProducts(previusValue => {
            const newValue = [...previusValue]
            newValue[index] = { ...newValue[index], [key]: value }
            return newValue
        })

    }

    const handleAddProduct = (e) => {
        e.preventDefault()
        setProducts(previusValue => {
            const newValue = [...previusValue]
            newValue.push({})
            return newValue
        })
    }

    const handleRemoveProduct = (e, index) => {
        e.preventDefault()
        setProducts(previusValue => {
            const newValue = [...previusValue]
            newValue.splice(index, 1)
            return newValue
        })
    }

    const handleChangeValue = (name, value) => {
        setData(previousValue => { return { ...previousValue, [name]: value } })
    }

    const handleChangeSaleDate = (date, dateEnd, time) => {
        const selectedDate = moment(`${date} ${time || "00:00"}`, "YYYY-MM-DD HH:mm")
        if (selectedDate.isValid()) {
            handleChangeValue("sold_at", selectedDate.toISOString())
        }
    }

    const handleCancel = (e) => {
        e.preventDefault()
        closeModal()
    }

    return (
        <Modal
            icon={<FiUsers />}
            title={isNew ? "Cadastro de nova venda" : "Edição de venda"}
            description={isNew ? "Registre uma nova venda para o lead" : "Altere as informações da venda"}
            closeModal={closeModal}
        >
            <form onSubmit={(e) => onSubmit(e, data, isNew)}>
                <FormGroupInline>
                    <FormGroup labelText="Data da venda">
                        <DatePicker
                            name="Data da venda"
                            dateStart={moment(data.sold_at).format("YYYY-MM-DD")}
                            timeStart={moment(data.sold_at).format("HH:mm")}
                            onChange={handleChangeSaleDate}
                            multiple={false}
                            showTime={true}
                        />
                    </FormGroup>
                </FormGroupInline>
                <FormGroupInline>
                    <FormGroup labelText="Descrição">
                        <Textarea placeholder="Descrição da venda" value={data.description ?? ""} onChange={(e) => handleChangeValue("description", e.target.value)} rows={3} />
                    </FormGroup>
                </FormGroupInline>
                <BreakForm title="Produtos" iconAction={<HiPlus />} actionVariant="primary" handleAction={handleAddProduct} />
                {products && products.map((product, index) => (
                    <FormGroupInline key={index} btnAction={index > 0}>
                        <FormGroup labelText={index === 0 && 'Produto'}>
                            <Select multiple={false} name="Produto" placeholder="Selecione um produto" options={listProducts || []} selected={product?.product_id ?? ""} onChange={(id) => handleChangeProduct("product_id", id, index)} invalid={true} textInvalid="Selecione um produto" />
                        </FormGroup>
                        <FormGroup labelText={index === 0 && 'Valor'}>
                            <Input type="currency" placeholder="Valor do produto" value={product?.value ?? ""} onChange={(e) => handleChangeProduct("value", e.target.value, index)} invalid={true} textInvalid="Preencha o valor do produto" />
                        </FormGroup>
                        {index > 0 && <Button variant='secondary' className='action' onClick={(e) => handleRemoveProduct(e, index)}><MdOutlineDelete /></Button>}
                    </FormGroupInline>
                ))}
                {isNew &&
                    <FormGroup labelText="Remover os produtos do lead após registrar a venda?">
                        <ToggleField
                            checked={data.removeProducts ?? false}
                            onChange={checked => handleChangeValue("removeProducts", checked)}
                            label="Remover produtos após registrar"
                            description="Os produtos vinculados ao lead serão removidos ao salvar esta venda."
                        />
                    </FormGroup>
                }
                <FormGroupInline>
                    <Button variant='primary' type="submit">Salvar</Button>
                    <Button variant='secondary' onClick={handleCancel}>Cancelar</Button>
                </FormGroupInline>
            </form>
        </Modal>
    )
}

export default ModalSale
